import { UserProfileAPI } from "@/apis/system";

export const UserProfileType = {
    INVENTORY: 1,
    OPEN_PO_REPORT: 2,
    OPEN_SO_REPORT: 3,
    SALES_REPORT: 4,
    LAST_SALES: 5,
    SO_PICKING_REPORT: 6,
    SO_FULFILLMENT_REPORT: 7,
    OPEN_SO_REPORT_BY_ITEM: 8,
}

export const UserProfile = {
    getProfile: async (type) => {
        const profile = await UserProfileAPI.get(type);
        if (!profile) {
            return null;
        }
        return JSON.parse(profile.profileContent);
    },
    saveProfile: async (type, data) => {
        await UserProfileAPI.save({ profileType: type, profileContent: JSON.stringify(data) });
    }
}